export function concatenatedStringArray(elements: string | string[]): string {
  return Array.isArray(elements) ? elements.join("\n") : elements;
}
